__turbopack_context__.v({
  "axisLabel": "gauge-bar-module-scss-module__LC1NBa__axisLabel",
  "curveGlow": "gauge-bar-module-scss-module__LC1NBa__curveGlow",
  "curveGlowHost": "gauge-bar-module-scss-module__LC1NBa__curveGlowHost" + " " + "gauge-bar-module-scss-module__LC1NBa__edgeMask",
  "curveLine": "gauge-bar-module-scss-module__LC1NBa__curveLine" + " " + "gauge-bar-module-scss-module__LC1NBa__edgeMask",
  "curveLineNoData": "gauge-bar-module-scss-module__LC1NBa__curveLineNoData" + " " + "gauge-bar-module-scss-module__LC1NBa__curveLine",
  "edgeMask": "gauge-bar-module-scss-module__LC1NBa__edgeMask",
  "gaugeHost": "gauge-bar-module-scss-module__LC1NBa__gaugeHost",
  "gaugeHostActive": "gauge-bar-module-scss-module__LC1NBa__gaugeHostActive",
  "gaugeSvg": "gauge-bar-module-scss-module__LC1NBa__gaugeSvg",
  "gaugeSvgNoData": "gauge-bar-module-scss-module__LC1NBa__gaugeSvgNoData" + " " + "gauge-bar-module-scss-module__LC1NBa__gaugeSvg",
  "pointer": "gauge-bar-module-scss-module__LC1NBa__pointer",
  "pointerGlow": "gauge-bar-module-scss-module__LC1NBa__pointerGlow",
  "targetTick": "gauge-bar-module-scss-module__LC1NBa__targetTick",
  "targetTickBadge": "gauge-bar-module-scss-module__LC1NBa__targetTickBadge",
  "targetTickPending": "gauge-bar-module-scss-module__LC1NBa__targetTickPending" + " " + "gauge-bar-module-scss-module__LC1NBa__targetTick",
  "targetTickReached": "gauge-bar-module-scss-module__LC1NBa__targetTickReached" + " " + "gauge-bar-module-scss-module__LC1NBa__targetTick",
  "targetTickStem": "gauge-bar-module-scss-module__LC1NBa__targetTickStem",
  "tickGroup": "gauge-bar-module-scss-module__LC1NBa__tickGroup" + " " + "gauge-bar-module-scss-module__LC1NBa__edgeMask",
  "tickMajor": "gauge-bar-module-scss-module__LC1NBa__tickMajor",
  "tickMinor": "gauge-bar-module-scss-module__LC1NBa__tickMinor",
  "tickWave": "gauge-bar-module-scss-module__LC1NBa__tickWave" + " " + "gauge-bar-module-scss-module__LC1NBa__tickMinor",
  "waveTick": "gauge-bar-module-scss-module__LC1NBa__waveTick",
});
